import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/shingle-vs-tile-roof.html")({
  beforeLoad: () => { throw redirect({ to: "/shingle-roofing", statusCode: 301 }); },
});
